export class DetalleCombustible{
    id: string;
    temperatura: number;
    densidad: number;
    cantidad15: number;
}